import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import s from './index.module.scss';

import { calculatePrice } from '../../../utils/scripts/calculatePrice';

import Option from '../Option';
import PromoCode from '../../../components/common/promoCode';

import { getPricesConfig } from '../../getPricesConfig';
import { RootState } from '../../../store';
import { PAYMENT_TARIFF } from '../../../types';
import { getCurrencySymbol } from '../../../utils/scripts/currency';
import { OfferProps, formatOptionTitle, useSingleOfferProduct, useSelectProduct } from '../offerShared';

/** v002/v003 are region-specific products — always shown in their own currency, regardless of ?subscrEU/?subscrUK. */
const FORCED_CURRENCY: Partial<Record<PAYMENT_TARIFF, string>> = {
  [PAYMENT_TARIFF.V002]: '€',
  [PAYMENT_TARIFF.V003]: '£',
};

/** Single-price offer variant (v001/v002/v003): one flat subscription option, no tiers to choose from. */
const OfferV7 = ({ currentProduct, secondScreenWrapper }: OfferProps) => {
  const tariff = useSelector((state: RootState) => state.data.tariff);

  const { firstPriceConfig } = getPricesConfig(tariff).everydoggyNewDesign;

  const currency = FORCED_CURRENCY[tariff as PAYMENT_TARIFF] ?? getCurrencySymbol();
  const prices = useSingleOfferProduct(firstPriceConfig, tariff);
  const doOnClick = useSelectProduct();

  const price = useMemo(
    () =>
      calculatePrice(prices.firstOption, {
        target: 'perDay',
        source: 'auto',
        defaultPrice: Number(firstPriceConfig.defaultPrice),
      }),
    [prices, firstPriceConfig]
  );

  return (
    <div className={`${s.optionsWrapper} ${s.optionStyleV2}`}>
      <PromoCode tariff={tariff} secondScreenWrapper={secondScreenWrapper} />
      <div className={s.options}>
        <Option
          className={s.option}
          selectedClassName={s.option__selected}
          currentProduct={currentProduct}
          optionValue={prices.firstOption?.id}
          productName={firstPriceConfig.productName}
          doOnClick={(val, pr) => doOnClick(val, pr, firstPriceConfig.defaultOldPrices)}
        >
          <div className={s.radio}></div>
          <div className={s.priceWrapepr}>
            <p className={s.priceWrapeprTitle}>{formatOptionTitle(firstPriceConfig.titleWeek)}</p>
            <p className={s.price}>
              {currency}
              {`${price}`}
            </p>
          </div>
        </Option>
      </div>
    </div>
  );
};

export default OfferV7;
